import React, { useState, useMemo } from 'react';
import { Modal, Button, Input, Empty, List } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const MissingCountriesModal = ({ visible, countries, onCancel, title }) => {
    const [searchValue, setSearchValue] = useState('');

    let countryList = [];
    if (Array.isArray(countries)) {
        countryList = countries.filter(c => c && c.length > 0);
    } else if (typeof countries === 'string') {
        countryList = countries.split(',').map(c => c.trim()).filter(c => c.length > 0);
    }

    const filteredCountries = useMemo(() => {
        if (!searchValue) return countryList;
        const lowerSearch = searchValue.toLowerCase();
        return countryList.filter(country => 
            country.toLowerCase().includes(lowerSearch)
        );
    }, [searchValue, countryList]);

    return (
        <Modal
            title={title || 'Missing Countries'}
            visible={visible}
            onCancel={onCancel}
            footer={[<Button key="close" type="primary" onClick={onCancel}>Close</Button>]}
            width="500px"
        >
            <div style={{ marginBottom: '16px' }}>
                <Input
                    placeholder="Search countries..."
                    prefix={<SearchOutlined />}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    allowClear
                    size="large"
                    style={{ borderRadius: '4px' }}
                />
                <p style={{ color: '#666', marginTop: '8px', fontSize: '12px' }}>
                    Showing {filteredCountries.length} of {countryList.length} countries
                </p>
            </div>

            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {filteredCountries.length === 0 ? (
                    <Empty description="No countries found" />
                ) : (
                    <List
                        dataSource={filteredCountries}
                        renderItem={(country, index) => (
                            <List.Item style={{ paddingLeft: 0, paddingRight: 0 }}>
                                <div style={{
                                    padding: '12px 16px',
                                    width: '100%',
                                    backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
                                    borderRadius: '4px',
                                    marginBottom: '4px',
                                    borderLeft: '4px solid #1890ff'
                                }}>
                                    {country}
                                </div>
                            </List.Item>
                        )}
                    />
                )}
            </div>
        </Modal>
    );
};

export default MissingCountriesModal;
